import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@companion-core/shared/app/Components/Button";
import { BellErrorProps } from ".";
import "Assets/Styles/scss/bellError.scss";

export const BellError = ({
  testID,
  buttonTestID,
  buttonLabel,
  className,
  onClick,
}: BellErrorProps) => {
  const { t } = useTranslation();

  return (
    <div data-testid={testID} className={`bell__error${className ? " " + className : ""}`}>
      <div className="bell__error-container">
        <img className="bell__error-image" src="/assets/images/error/server_error.svg" alt="" />
        <h3 className="bell__error-title title-2">{t("common.error.500.title")}</h3>
        <div className="bell__error-subtitle body-text-6">{t("common.error.500.text")}</div>
      </div>
      <div className="bell__error-button">
        <Button
          testID={buttonTestID}
          type="primary"
          size="full"
          label={buttonLabel ?? t("common.error.500.button")}
          onClick={onClick}
        />
      </div>
    </div>
  );
};
